import { AppThunk } from "../../../../store";
import { openapi } from "../../../../../openapi";
import saveAs from "file-saver";
import { setShowFailedMessageThunk } from "../../../../global/globalSlice";

export const base64TilBlob = (base64: string, mime: string): Blob => {
  const bin = atob(base64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type: mime });
};

export const thunkGenerateChecklistReportDocxAndDownload =
  (): AppThunk<Promise<void>> => async (dispatch, getState) => {
    const checklist = getState().checklistReducer.checklist;
    const signedBy = getState().globalReducer.user;
    if (!checklist || !signedBy) {
      const missing: string[] = [];
      if (!checklist) missing.push("checklist");
      if (!signedBy) missing.push("signedBy");
      if (missing.length) {
        console.error("Manglende data for å generere sjekkliste-DOCX. Mangler:", missing.join(", "));
        return;
      }
    }

    try {
      const result = await dispatch(
        openapi.endpoints.postChecklistIntegrationGenerate.initiate({
          body: {
            checklistId: checklist.id,
            signedBy: signedBy.name || signedBy._id,
          },
        }),
      ).unwrap();

      const blob = base64TilBlob(result.base64, result.mime);
      saveAs(blob, result.filename);
    } catch (err) {
      dispatch(
        setShowFailedMessageThunk(
          "Noe gikk galt ved generering av sjekkliste-DOCX. Prøv igjen, eller kontakt support hvis problemet vedvarer.",
        ),
      );
    }
  };
